import { render } from "./VModal.vue?vue&type=template&id=2346e096&scoped=true"
import script from "./VModal.vue?vue&type=script&lang=js"
export * from "./VModal.vue?vue&type=script&lang=js"

import "./VModal.vue?vue&type=style&index=0&id=2346e096&lang=scss"
import "./VModal.vue?vue&type=style&index=1&id=2346e096&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2346e096"]])

export default __exports__